import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.sass'],
})
export class ChangePasswordModalComponent {
  currentPassword = '';
  newPassword = '';
  confirmPassword = '';
  loading = false;

  showCurrent = false;
  showNew = false;
  showConfirm = false;

  constructor(
    private dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    private authService: AuthService,
    private toastService: ToastService
  ) {}

  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  get isFormValid(): boolean {
    return (
      this.currentPassword.trim().length > 0 &&
      this.newPassword.trim().length >= 6 &&
      this.passwordsMatch
    );
  }

  onSubmit(): void {
    if (!this.isFormValid || this.loading) {
      return;
    }

    this.loading = true;
    this.authService
      .changeOwnPassword({
        password: this.currentPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.loading = false;
          this.toastService.showSuccess('Senha alterada com sucesso!');
          this.dialogRef.close(true);
        },
        error: (err: any) => {
          this.loading = false;
          const msg =
            err?.error?.message ||
            'Erro ao alterar a senha. Verifique a senha atual e tente novamente.';
          this.toastService.showError(msg);
        },
      });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
